import { useState, useEffect } from "react";
import HeaderBar from "../HeaderBar";
import useStateMachineWrapper from "../../helpers/useStateMachineWrapper";
import useCalculators from "../../helpers/useCalculators";

import {ReactComponent as PodOneBlue} from "../../assets/images/1-pod-blue.svg";
import {ReactComponent as PodOneWhite} from "../../assets/images/1-pod-white.svg";
import {ReactComponent as PodTwoBlue} from "../../assets/images/2-pod-blue.svg";
import {ReactComponent as PodTwoWhite} from "../../assets/images/2-pod-white.svg";
import {ReactComponent as PodThreeBlue} from "../../assets/images/3-pod-blue.svg";
import {ReactComponent as PodThreeWhite} from "../../assets/images/3-pod-white.svg";
import {ReactComponent as PodFourBlue} from "../../assets/images/4-pod-blue.svg";
import {ReactComponent as PodFourWhite} from "../../assets/images/4-pod-white.svg";

import ContentButton from "../ContentButton";
import { dataLayerPush } from "../../helpers/analytics";
import MobileNextButton from "../MobileNextButton";

const ChooseWifi = (props) => {
  const {actions, state, sendState} = useStateMachineWrapper();

  const {getApplicablePromo} = useCalculators();

  // set it once on initial load (useful for if we're setting a default speed)
  useEffect(() => {
    if(state.session.pods/* && !state.session.promoID*/) {
      const checkForPromo = getApplicablePromo({
        pods: state.session.pods,
        groupId: state.session.promoGroupID
      });
      if(checkForPromo) {
        actions.update({
          promo: checkForPromo,
          promoID: checkForPromo.id,
          promoName: checkForPromo.description,
        });
      }
    }
  }, []);

  const selectPods = (val) => {
    // TODO: get pod price from session
    const firstPodPrice = state.session.speed!=='8000' ? 7 : 0;//state.session.speed === '1000' ? 0 : 7;
    let podPrice = 0;
    if(parseInt(val) > 1) {
      podPrice = firstPodPrice+(parseInt(val)-1)*5;
    } else if(parseInt(val) == 1) {
      podPrice = firstPodPrice;
    }

    actions.update({
      pods: val,
      podsAmount: podPrice.toString(),
    });

    const checkForPromo = getApplicablePromo({
      pods: val,
      groupId: state.session.promoGroupID
    });
    if(checkForPromo) {
      actions.update({
        promo: checkForPromo,
        promoID: checkForPromo.id,
        promoName: checkForPromo.description,
      });
    } else {
      actions.update({
        promo: null,
        promoID: '',
        promoName: '',
      });
    }

    dataLayerPush({
      'event' : 'change_wifi',
      'WiFi' : parseInt(val),
      'WiFi-total' : podPrice
  })
  }

  const availablePods = state.session.speed!=='8000' ? ['1', '2', '3', '4', '0'] : ['0'];

  let firstPodPrice = 7;
  let secondPodPrice = 5;
  let firstPodPrice_regular = 7;
  let secondPodPrice_regular = 5;

  const checkForPromo = getApplicablePromo({
    pods: state.session.pods,
    groupId: state.session.promoGroupID
  });
  if(checkForPromo && checkForPromo.discount.hasOwnProperty('pods_included')) {
    if(checkForPromo.discount.pods_included > 0){
      firstPodPrice = 0;
      if(checkForPromo.discount.pods_included == 2){
        secondPodPrice = 0;
      }
    }
  }
//console.log(state.session.promo);

  // const firstPodPrice = state.session.speed === '1000' ? 0 : 7;
  if(state.session.promo !== null){
    if (state.session?.promo?.description !== null) {
    // console.log('promo found');
      if (state.session.promo.description.includes("$100 Streaming Choice Card")) {
        sessionStorage.setItem('holiday_promo', true);
        //document.cookie = "holiday_promo=true;";
        //console.log('100 found');
      }else {
        //console.log('100 not found');
        //document.cookie = "holiday_promo=false;";
        sessionStorage.removeItem('holiday_promo');
        //document.cookie('holiday_promo', false, { expires: 1 });
      }
    }
  }
  
  const podInfo = state.session.speed!=='8000' ? {
    '1': {
      info: 'Small studios, 1-2 bedroom apartments and houses',
      cost: firstPodPrice,
      regular_cost : firstPodPrice_regular,
    },
    '2': {
      info: '2-3 bedroom homes, condos, and townhomes. For homes over 1,200 – 1,800 sq. ft. on one or two floors.',
      cost: firstPodPrice+secondPodPrice,
      regular_cost : firstPodPrice_regular+secondPodPrice_regular,
    },
    '3': {
      info: '3-4 bedroom homes with over 1,800 sq. ft. of living space, including finished basements, porches and patios.',
      cost: firstPodPrice+secondPodPrice+5,
      regular_cost : firstPodPrice_regular+secondPodPrice_regular+5,
    },
    '4': {
      info: '5+ bedroom homes with over 5,000 sq. ft. of living space, including basements, porches and patios.',
      cost: firstPodPrice+secondPodPrice+10,
      regular_cost : firstPodPrice_regular+secondPodPrice_regular+10,
    },
    '0': {
      info: 'For best performance on our network, use of i3 Smart WiFi equipment is recommended. Cable modems and cable modem/router combination units are not compatible with i3 Broadband\'s services. We are not able to guarantee performance of non-i3 Smart WiFi equipment used on our network. If you choose to use your own router, please note that it must be gigabit capable.',
      cost: 0,
    },
  } : {'0': {
    info: 'Because 8-Gig customer Wi-Fi needs are unique to their individual equipment and device configurations, i3 does not supply routers or extenders for our 8 Gig product.',
    cost: 0,
  },}

  const selectedWifi = podInfo[state.session.pods] ?? null;
  const isForeverPromo = state.session?.promo?.extras?.TimeSpanType === 'F';
  const wifiTerms = state.session?.promo?.extras?.wifi_terms;
  let discount = false;
  return (<>
        {/* <Breadcrumbs /> */}
        <HeaderBar backPage={'choose-internet'} nextPage={'order-summary'}>
          <h1 className="bigger">How Many Smart Wifi Devices Do You need?</h1>
          <p>The size and layout of your home will determine how many Smart WiFi Devices you need. Our WiFi Pod Devices work as both routers and extenders.</p>
        </HeaderBar>


        <div className="grid grid-flow-row-dense grid-cols-1 md:grid-cols-2 gap-4 my-4">
          {availablePods.map(num => {
            let tier = podInfo[num];
            
            if(tier.cost != tier.regular_cost) discount = true;

            const isActive = state.session.pods === num;

            let name = `${num} Smart WiFi`;
            if(num === '0') {
              name = 'Use My Own Router';
            }

            return (
              <ContentButton key={num} className={`flex flex-col gap-4 pb-4 justify-between ${num === '0' && 'md:col-span-2'}`} isActive={isActive} onClick={()=>selectPods(num)}>
              {num === '1' && (<>
                {isActive === true && <PodOneWhite height={40}/>}
                {isActive !== true && <PodOneBlue height={40}/>}
              </>)}
              {num === '2' && (<>
                {isActive === true && <PodTwoWhite height={40}/>}
                {isActive !== true && <PodTwoBlue height={40}/>}
              </>)}
              {num === '3' && (<>
                {isActive === true && <PodThreeWhite height={40}/>}
                {isActive !== true && <PodThreeBlue height={40}/>}
              </>)}
              {num === '4' && (<>
                {isActive === true && <PodFourWhite height={40}/>}
                {isActive !== true && <PodFourBlue height={40}/>}
              </>)}

                <div>
                  <p className="text-5xl font-black !leading-none">{name}</p>
                </div>

                <div className="flex-1 mlr38">
                  <p className={`text-left text-sm uppercase font-black ${isActive ? 'text-white' : 'text-gray'}`}>{num === '0' ? 'Important Information': 'Recommended For'}:</p>
                  <p className={`text-left ${num === '0' ? 'text-xs' : 'text-sm'} ${isActive ? 'text-white' : 'text-gray-700'}`}>{tier.info}</p>
                </div>

                {tier.cost === 0 && (<p className="text-3xl font-bold !leading-none">No Additional Charge</p>)}
                {tier.cost === 0 && num !== '0' && (isForeverPromo
                  ? (wifiTerms && <p className="!text-sm !leading-none font-bold all-lowercase">{wifiTerms}</p>)
                  : (state.session?.promo?.extras?.hasOwnProperty('wifi_terms') && <p className="!text-sm !leading-none font-bold all-lowercase">{wifiTerms} ${tier.regular_cost}/mo. thereafter</p>)
                )}

                {tier.cost !== 0 && (
                <div>
                  <p className="text-3xl font-bold !leading-none">{tier.disclaimer ? <sup className="opacity-0 select-none">*</sup> : null}${tier.cost}/mo.{tier.disclaimer ? <sup>*</sup> : null}</p>
                  {discount && (isForeverPromo
                    ? (wifiTerms && <p className="!text-sm !leading-none font-bold">{wifiTerms}</p>)
                    : <p className="!text-sm !leading-none font-bold">{wifiTerms} ${tier.regular_cost}/mo. thereafter</p>
                  )}
                </div>
                )}
              </ContentButton>
            );
          })}
        </div>

        <div>
          <div className="py-2 py-4 rounded-t-lg bg-blue text-white font-bold text-center">How Our Smart WiFi Devices Work Better For You!</div>
          <video controls={true} src="https://www.i3broadband.com/media/Plume-How-to-v08.mp4"></video>
        </div>
        <HeaderBar backPage={'choose-internet'} nextPage={'order-summary'}></HeaderBar>
    </>)

};

export default ChooseWifi;